// =============================================================================
// src/features/analytics/analytics-route.ts — Rota fullscreen do Analytics.
// =============================================================================

import { qs } from '../../app/dom';
import {
  getExploreRouteGlobal,
  getGrafoRoute,
  getTopbarNav,
  getWorkspaceRoute,
} from '../explore/explore-globals';

const ANALYTICS_VIEW_CLASS = 'is-analytics-view';
const CINEMA_ACTIVE_CLASS = 'cinema-active';

interface ClosableSiblingRoute {
  isOpen(): boolean;
  close(): void;
}

interface AnalyticsRouteWindow {
  BriefingRoute?: ClosableSiblingRoute;
  MapaIaRoute?: ClosableSiblingRoute;
}

class AnalyticsFullscreenRoute {
  private page: HTMLElement | null = null;

  /** Resolve a pagina uma vez apos mountRouteLayer montar o DOM. */
  init(): void {
    this.page = qs<HTMLElement>('#u-analytics-page');
  }

  /** Indica se a rota Analytics esta aberta. */
  isOpen(): boolean {
    return document.body.classList.contains(ANALYTICS_VIEW_CLASS);
  }

  /** Abre Analytics, fecha rotas irmas e sincroniza a topbar. */
  open(): void {
    if (this.isOpen()) return;
    this.closeSiblingRoutes();
    document.body.classList.remove(CINEMA_ACTIVE_CLASS);
    document.body.classList.add(ANALYTICS_VIEW_CLASS);
    this.page?.setAttribute('aria-hidden', 'false');
    getTopbarNav()?.syncActive();
  }

  private closeSiblingRoutes(): void {
    const win = window as unknown as AnalyticsRouteWindow;
    if (win.BriefingRoute?.isOpen()) win.BriefingRoute.close();
    if (getExploreRouteGlobal()?.isOpen()) getExploreRouteGlobal()?.close();
    if (getGrafoRoute()?.isOpen?.()) getGrafoRoute()?.close();
    if (getWorkspaceRoute()?.isOpen?.()) getWorkspaceRoute()?.close();
    if (win.MapaIaRoute?.isOpen()) win.MapaIaRoute.close();
  }

  /** Fecha Analytics e sincroniza a topbar. */
  close(): void {
    if (!this.isOpen()) return;
    document.body.classList.remove(ANALYTICS_VIEW_CLASS);
    this.page?.setAttribute('aria-hidden', 'true');
    getTopbarNav()?.syncActive();
  }
}

export const AnalyticsRoute = new AnalyticsFullscreenRoute();

